<h3 mat-dialog-title style="color: red;">Pitch Update Confirmation</h3>

  <form [formGroup]="updateFormGroup">
    <br>
    
    <div>
        You are about to open or block pitch 
            <b> {{pitchID}}
            <span *ngIf = "subassemblyID !=''"> ({{subassemblyID}})</span>
            <span *ngIf = "pitchName !=''"> {{pitchName}}</span>
            </b>; including the attached <b>{{variantCount}} variant(s)</b>. 
        All associated work will be deleted. If you wish to proceed please Type in <strong>'YES'</strong> and click confirm to <strong>DELETE</strong>
    </div>

    <mat-form-field class="card-dialog">
    <input id="updateConfirmation" type="string" matInput cdkTextareaAutosize formControlName="form_updateConfirmation" required>
    </mat-form-field>

    <div *ngIf="updateFormGroup.get('form_updateConfirmation')?.invalid && updateFormGroup.get('form_updateConfirmation')?.errors 
        && (updateFormGroup.get('form_updateConfirmation')?.dirty || updateFormGroup.get('form_updateConfirmation')?.touched)">
    <small class="error" *ngIf="updateFormGroup.get('form_updateConfirmation')?.hasError('required')">
        Confirmation is required.
    </small>
    <small class="error" *ngIf="updateFormGroup.get('form_updateConfirmation')?.hasError('confirmation')">
        Confirmation should be typed in as "YES" 
    </small>
    </div>
</form>


<div mat-dialog-actions>
    <button  mat-raised-button [disabled]="updateFormGroup.status === 'INVALID'"color="warn" (click)="confirmUpdate()">CONFIRM</button>
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="onNoClick()">Close</button>
</div>

